




























import Vue from "vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  props: ["item"],
  components: {
    SensitivityLabel,
  },
  setup(props) {
    const borderLeftColor = computed(() => {
      const levels = {
        None: "var(--primary)",
        Low: "var(--level-l)",
        Medium: "var(--level-m)",
        High: "var(--level-h)",
      };
      // @ts-ignore
      return levels[props.item.severity];
    });

    return { borderLeftColor };
  },
});
